import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed, ref } from "vue";
import { getClasses } from "~/js/composables/classes";
import { Badge } from "~/js/interfaces/colors";
import { sanitizeHtml } from "~/js/utils/sanitize-html";

interface Props {
	content: string;
	style: Badge;
	size?: "small" | "default";
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BadgePrimary',
  props: {
    content: {},
    style: {},
    size: { default: "default" },
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	display: "rounded-full",
	font: "font-primary text-sm font-medium text-black",
	padding: props.size === "default" ? "py-2 px-3" : "px-3 py-1",
	text: "truncate max-w-54",
});

const sanitizedContent = computed(() => sanitizeHtml(props.content));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([_unref(getClasses)(classes.value), __props.style.background, __props.style.text, __props.utilities]),
    innerHTML: sanitizedContent.value
  }, null, 10, _hoisted_1))
}
}

})